function isTaxNumberValid (nip) {
  if (typeof nip !== 'string') {
    return false;
  }

  if (nip.length !== 10) {
    return false;
  }

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;

  weights.forEach((weight, index) => {
    sum += (parseInt(nip[index]) * weight);
  });
  
  const controlNumber = parseInt(nip.substring(9, 10));

  return sum % 11 === controlNumber;
}

export { isTaxNumberValid };
